export default {
    mounted() {
        this.addWindowResizeListener();
    },
    beforeDestroy() {
        this.removeWindowResizeListener();
    },
    methods: {
        onWindowResize() {
            //
        },
        addWindowResizeListener() {
            try {
                window.addEventListener('resize', this._.debounce(this.onWindowResize, 200));
                window.addEventListener('orientationchange', this._.debounce(this.onWindowResize, 200));
            } catch (error) {
                //
            }
        },
        removeWindowResizeListener() {
            try {
                window.removeEventListener('resize', this._.debounce(this.onWindowResize, 200));
                window.removeEventListener('orientationchange', this._.debounce(this.onWindowResize, 200));
            } catch (error) {
                //
            }
        }
    }
};
